












































// Importing components
import BaseInputField from '@/ui/BaseInputField.vue';
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';

export default {
    name: 'TheFormRegister',
    components: {
        BaseLoadingAnimation,
        BaseInputField,
    },
    props: {
        userData: {
            type: Object,
            required: true,
        },
    },
    computed: {
        loading() {
            return this.$store.getters.loading;
        },
    },
    data() {
        return {};
    },
    methods: {
        onSubmit() {
            this.$emit('submit');
        },
    },
};
